import { render, staticRenderFns } from "./jiaoyiTable2.vue?vue&type=template&id=378ec828"
import script from "./jiaoyiTable2.vue?vue&type=script&lang=js"
export * from "./jiaoyiTable2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/check/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('378ec828')) {
      api.createRecord('378ec828', component.options)
    } else {
      api.reload('378ec828', component.options)
    }
    module.hot.accept("./jiaoyiTable2.vue?vue&type=template&id=378ec828", function () {
      api.rerender('378ec828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widget/jiaoyiTable2.vue"
export default component.exports